import { AbstractRestService } from "../abstractRestService";
import { Role } from "../../model/user/role";

export class RoleService extends AbstractRestService<Role> {
    constructor() {
      super('/api/roles');
    }
}

export const roleService = new RoleService();